import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ShieldCheck, KeyRound, CheckCircle2 } from "lucide-react";
import { api, formatApiError } from "../api";

export default function ResetPassword() {
  const { token } = useParams();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) {
      setError("Şifreler eşleşmiyor.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      setDone(true);
      setTimeout(() => navigate("/giris"), 2500);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen pt-24 pb-16 flex items-center justify-center px-4 carbon-texture">
      <div className="w-full max-w-md rounded-2xl backdrop-blur-xl bg-slate-900/80 border border-white/10 shadow-2xl p-8 animate-fade-up">
        <div className="flex items-center gap-3">
          <span className="w-10 h-10 rounded-lg bg-cyan-400/10 border border-cyan-400/40 flex items-center justify-center">
            <ShieldCheck className="w-5 h-5 text-cyan-300" />
          </span>
          <h1 className="text-2xl font-bold text-white">Yeni Şifre Belirle</h1>
        </div>

        {done ? (
          <div data-testid="reset-success" className="mt-6 rounded-xl border border-emerald-500/30 bg-emerald-500/10 p-5 flex items-start gap-3">
            <CheckCircle2 className="w-5 h-5 text-emerald-300 shrink-0 mt-0.5" />
            <div>
              <p className="text-sm text-emerald-300 font-semibold">Şifreniz güncellendi</p>
              <p className="mt-1 text-sm text-slate-300">Giriş sayfasına yönlendiriliyorsunuz...</p>
            </div>
          </div>
        ) : (
          <>
            <p className="mt-2 text-sm text-slate-400">Yeni şifrenizi belirleyin. Bağlantı tek kullanımlıktır.</p>
            <form onSubmit={submit} className="mt-7 space-y-5">
              <div>
                <label className="text-xs font-semibold text-slate-400 uppercase tracking-wider">Yeni Şifre</label>
                <input data-testid="reset-password-input" type="password" required minLength={6} value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="mt-1.5 w-full px-4 py-3 rounded-xl bg-slate-950/70 border border-white/10 text-slate-100 focus:outline-none focus:border-cyan-400/60 transition-colors"
                  placeholder="En az 6 karakter" />
              </div>
              <div>
                <label className="text-xs font-semibold text-slate-400 uppercase tracking-wider">Yeni Şifre (Tekrar)</label>
                <input data-testid="reset-password-confirm-input" type="password" required minLength={6} value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  className="mt-1.5 w-full px-4 py-3 rounded-xl bg-slate-950/70 border border-white/10 text-slate-100 focus:outline-none focus:border-cyan-400/60 transition-colors"
                  placeholder="Şifrenizi tekrar girin" />
              </div>
              {error && <p data-testid="reset-error" className="text-sm text-red-400">{error}</p>}
              <button data-testid="reset-submit-button" type="submit" disabled={loading}
                className="w-full flex items-center justify-center gap-2 py-3.5 rounded-xl bg-cyan-400 text-slate-950 font-bold hover:bg-cyan-300 hover:shadow-[0_0_20px_rgba(249,115,22,0.4)] active:scale-[0.99] transition-all disabled:opacity-50">
                <KeyRound className="w-4 h-4" /> {loading ? "Kaydediliyor..." : "Şifremi Güncelle"}
              </button>
            </form>
            <p className="mt-6 text-sm text-slate-400 text-center">
              <Link data-testid="reset-back-login" to="/giris" className="text-cyan-300 hover:text-cyan-200 font-semibold">
                Giriş sayfasına dön
              </Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
